import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import CulturalForm from '../Forms/CulturalForm'
import Modal from './Modal'


const Cultural = () => {
  const[open, setOpen]=useState(false);
  const datas =[
    {
      image:"/assets/images/culture/bhawa.png",
      culture:"Bhawai Dance ",
      desc:" Bhavai is one of the traditional folk dances of Rajasthan. This is a very difficult form of dance and can only be performed by skilled artists. "
    },
    {
      image:"/assets/images/culture/dfdfx.png",
      culture:"Parda Dance",
      desc:" A great attraction of Rajasthan is the Parda dances. Bringing alive the Thar Desert of Rajasthan, the dancers present a wide variety of amazing dances. "
    },
    {
      image:"/assets/images/culture/fok.png",
      culture:"Rajasthani Folk Bollywood",
      desc:" Rajasthans most sophisticated style of folk music and has come a long way from the time it was only sung in royal courts, in praise of the Rajput rulers. "
    },
    {
      image:"/assets/images/culture/gajal.png",
      culture:"Chari Dance",
      desc:" The Chari dance is performed at marriage celebrations, on the birth of a male child and at celebrations and festivals of goodness. "
    },
    {
      image:"/assets/images/culture/kalll.png",
      culture:"Kalbeliya Dance",
      desc:" Kabeliya is one of the most famous dance forms of Rajasthan, performed by a tribe of the same name are traditional serpent charmers. "
    },
    {
      image:"/assets/images/culture/tars.png",
      culture:"Taraju Dance",
      desc:" Tarazu symbolises the equilibrium that the people of Rajasthan maintain in all aspects of their life of Rajasthan does a balancing act,  harmonious blend."
    },
    {
      image:"/assets/images/culture/qwasww.png",
      culture:"Gajal Qawalli Songs",
      desc:" Gajal Qwali is a traditional folk dance of Rajasthan. It was the Bhil tribe who performed it to worship Goddess Saraswati  by  Rajasthani communities.  "
    }
  ]
  return (
    <div>
     <div style={{ backgroundPosition:"center", backgroundImage:' url(/assets/Bh.jpg)' ,   animationDuration: '1.5s',
          animationDelay: '0.4s',
          animationName: 'fadeInDown'}} className=' text-4xl md:text-7xl w-full h-[400px]  bg-cover bg-opacity-20 duration-500   flex flex-col justify-around items-center text-center py-4  mb-4'>
               <div className='text-white font-serif tracking-widest   drop-shadow-2xl pt-10 mt-24'> <h1 >CULTURAL TOURISM</h1></div>
                
                <div>
                    <ol className='w-[fit-content] px-4  flex gap-1 text-xl py-1 my-4  text-black  rounded bg-white'>
                        <li  className='cursor-pointer italic hover:text-[#433a8b] text-black/30 ' ><Link to={'/'}>Home </Link></li>
                        <li>/Cultural Tourism</li>
                    </ol>
                    <div className=' my-0'><button onClick={()=>{setOpen(true)}} className='px-4 animate-pulse py-2 text-lg font-medium rounded-lg text-black hover:bg-white/80 bg-white'>Book Now</button></div> 
          
                </div>
                <Modal open={open} onClose={() => {setOpen(false)

}}>
  <div className='mx-auto my-4  '>

     <CulturalForm/>

  </div>
</Modal>
                </div>
                <div className=' p-4 m-8  flex flex-wrap items-center justify-center relative'>
                 {
                  datas.map((e)=>(
<div className='container h-max  hover:rotate-3 m-3 w-[400px]'>
<img src={e.image} alt="/" />
<h1 className='italic text-xl font-medium'>
  {e.culture}
</h1>
<p className='font-light'>{e.desc}</p>
</div>
                  ))
                 }
                </div>
   
                    
      
    </div>
  )
}

export default Cultural
